import { useAuth } from '../context/AuthContext';

export default function Navbar() {
  const { user, logout } = useAuth();

  return (
    <nav className="navbar navbar-dark bg-primary px-3">
      <span className="navbar-brand fw-bold">Focusly</span>
      {user && (
        <div className="d-flex align-items-center gap-3">
          <span className="text-white">{user.name}</span>
          <button className="btn btn-outline-light btn-sm" onClick={logout}>
            Logout
          </button>
        </div>
      )}
    </nav>
  );
}
